import { WSFilter } from "@wingspanhq/fe-component-library";
import { PayrollCycleType } from "@wingspanhq/wingspan-api-sdk";

import { PAYROLLS_CYCLE_FILTER_ALL } from "./types";

export function buildPayrollsFiltersConfig(): WSFilter[] {
  return [
    {
      title: "Cycle",
      name: "cycleType",
      type: "radio",
      options: [
        { name: PAYROLLS_CYCLE_FILTER_ALL, label: "All", hidePill: true },
        { name: PayrollCycleType.ON_CYCLE, label: "On-cycle" },
        { name: PayrollCycleType.OFF_CYCLE, label: "Off-cycle" }
      ]
    }
  ];
}
